// Vendors
import { TweenMax, Power3, ScrollToPlugin } from "gsap/all";
const scrollPlugin = ScrollToPlugin;

// Utilities
import Config from "../constants/Config";
import { qs, qsa, cls } from "./util/dom-utils";
import pubsub from "./util/pubsub";

class Pagination {
    static classes = {
        isCurrent: "is-current"
    };

    static selectors = {
        list: ".pagination__list",
        anchors: ".pagination__list li a"
    };

    constructor(el) {
        // Elements
        this.$el = el;

        this.$pagination = qs(Pagination.selectors.list);
        this.$anchors = qsa(Pagination.selectors.anchors, this.$el);

        this.isActive = false;
        this.lastId = 0;
        this.id = 0;

        this.attachEvents();
        this.changeSection(0);
    }

    changeSection(id) {
        this.id = id;

        // Assignment class to current element
        if (this.lastId !== this.id) {
            this.lastId = this.id;

            this.$anchors.forEach(elem => {
                let href = elem.hash.substr(1);
                elem.classList[href === this.id ? "add" : "remove"](Pagination.classes.isCurrent);
            });

            pubsub.publish(Config.events.PAGINATION_CHANGE, this.id);

        }

    }

    enterAnimation() {

        cls.add(this.$el, "is-visible");

    }

    leaveAnimation() {

        cls.remove(this.$el, "is-visible");

    }

    attachEvents() {

        this.scrollToSection = (e) => {
            e.preventDefault();
            const el = e.currentTarget;
            const sectionClicked = el.getAttribute("href").slice(1);

            const $section = qs(`section[data-index="${sectionClicked}"]`);

            if ($section) {
                let pointAnchor = $section.offsetTop;

                if (window.Modernizr.touch && window.innerWidth > 768) {
                    // Ipad portrait
                    TweenMax.to(window, 1, {
                        scrollTo: { y: pointAnchor + 10, autoKill: false }
                    });
                }
                else {
                    TweenMax.to(window, 1, {
                        scrollTo: { y: pointAnchor },
                        ease: Power3.easeInOut
                    });
                }

                pubsub.publish("pagination::click");
            }
        }

        this.$anchors.forEach(el => {
            el.addEventListener(Config.events.CLICK, this.scrollToSection);
        });

        //from section.js
        pubsub.subscribe(Config.events.SECTION_CHANGE, (id) => {
            this.changeSection(id);
        });

        //from border.js
        pubsub.subscribe(Config.events.BORDERS_CHANGE, (event) => {
            (event === "enter") ? this.enterAnimation() : this.leaveAnimation();
        });

        pubsub.subscribe(Config.events.LOADER_GONE, (event) => {
            this.enterAnimation();
        });
    }

}

export default Pagination;

const _init = () => {

    // Elements
    let $el = qs(".pagination");

    if ($el) {
        new Pagination($el);
    }
};

_init();
